/**
 * @generated SignedSource<<1a436af569722b8fbe3dc952ba14e4fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRingMeasurementType_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAppliedFilterUrlLabel_itemSearch">;
  readonly " $fragmentType": "useRingMeasurementType_itemSearch";
};
export type useRingMeasurementType_itemSearch$key = {
  readonly " $data"?: useRingMeasurementType_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRingMeasurementType_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRingMeasurementType_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAppliedFilterUrlLabel_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a52c20069292f29639582f5ecbb5588b";

export default node;
